import {Navigate} from "react-router-dom";

import {useIsAuthenticated} from "../store/session";

export default function AuthGuard({children}: {children: React.ReactNode}) {
  const isAuthenticated = useIsAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
